import React from 'react';
import { LinkButton } from 'framework/ui/ui-builder';
import { useAssetId, useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';

const AllNotesButton = () => {
  const id = useAssetId();
  const { getTimelineUrl } = useAssetUrl();

  return (
    <LinkButton
      url={getTimelineUrl(id)}
      variant="outlined"
      startIcon={
        <i
          style={{
            fontSize: '1.2em',
          }}
          className="fa fa-sticky-note"
          aria-hidden
        />
      }
    >
      <span>View all notes</span>
    </LinkButton>
  );
};

export default AllNotesButton;
